module.exports = __webpack_public_path__ + "static/media/klimbingkioskthumb.f381c3be.png";